import * as UI from "@iyk/ui"

import { AppLink, type AppRoute, useForm } from "@iyk/react-router/client"
import { DataTestId } from "../DataTestId.ts"
import { Card } from "./Card.tsx"
import { DrawerDropdown } from "./DrawerDropdown.tsx"
import { UserAvatar } from "./UserAvatar.tsx"

export const UserMenu = ({
  name,
  email,
  avatar,
  logoutRoute,
  settingsRoute,
  trigger,
  triggerClassName
}: UserMenu.Props) => {
  const { Form, isSubmitting } = useForm()

  return (
    <DrawerDropdown.Root>
      <DrawerDropdown.Trigger
        className={UI.cx("outline-none focus-visible:ring-4 focus-visible:ring-gray-9", triggerClassName)}
        data-testid={DataTestId.userMenu}
      >
        {trigger}
      </DrawerDropdown.Trigger>
      <DrawerDropdown.Content dropdownProps={{ align: "end" }}>
        <Card rounded="base" padding="sm" className="flex items-center gap-3">
          <UserAvatar url={avatar} name={name} size="md" />
          <div className="flex flex-col gap-0.5">
            <p className="text-sm font-medium">{name}</p>
            <p className="text-xs text-gray-11">{email}</p>
          </div>
        </Card>
        <DrawerDropdown.Menu.Root>
          <DrawerDropdown.Menu.Item>
            <AppLink to={settingsRoute}>
              <UI.Icon.Settings />
              User settings
            </AppLink>
          </DrawerDropdown.Menu.Item>
          <Form method="post" action={logoutRoute} className="flex" reloadDocument>
            <DrawerDropdown.Menu.Item>
              <button
                className="gap-3 flex items-center w-full"
                type="submit"
                disabled={isSubmitting}
                data-testid={DataTestId.userMenuLogout}
              >
                <UI.Icon.Logout />
                Logout
              </button>
            </DrawerDropdown.Menu.Item>
          </Form>
        </DrawerDropdown.Menu.Root>
      </DrawerDropdown.Content>
    </DrawerDropdown.Root>
  )
}

export namespace UserMenu {
  export type Props = {
    name: string
    email: string
    avatar?: string
    logoutRoute: AppRoute
    settingsRoute: AppRoute
    trigger: React.ReactNode
    triggerClassName?: string
  }
}
